// extracted by mini-css-extract-plugin
module.exports = {"voucherSection":"Vouchers-module__voucherSection___iiIl8","voucherWelcome":"Vouchers-module__voucherWelcome___23fX_"};